import { createSlice } from "@reduxjs/toolkit"

import moment from "moment"

export const errorsSlice = createSlice({
  name: "errors",
  initialState: [],
  reducers: {
    add: (state, action) => {
      // Unieke key koppelen aan error
      action.payload.key = moment().valueOf()
      state.push(action.payload)
    },
    remove: (state, action) => {
      state.splice(action.payload.index, 1)
    },
    clear: (state) => {
      return []
    }
  }
})

export const { add: addError, remove: removeError, clear: clearError } = errorsSlice.actions

export default errorsSlice.reducer

export const catchMessage = (json, functionName, successText) => (dispatch) => {
  let message = "Error"
  let type = (json && json.type && json.type.toLowerCase())

  if (json) {
    if (type === "success" || successText) {
      if (successText) {
        message = successText
        type = (type ? type : "info")
      } else {
        return null
      }
    } else {
      if (json.exception) {
        message = json.exception.toString()

        if (!type) {
          type = "critical"
        }
      } else {
        return null
      }
    }
  }

  dispatch(addError({
    message: message,
    number: json && json.exception && json.exception.number,
    level: json && json.exception && json.exception.level,
    function: functionName,
    type: type
  }))
}